import React, { useContext } from 'react';
import { DataContext } from '../../DataDetails';
import FutureEarnings from '../../components/FutureEarnings/FutureEarnings';
// import PastInstalls from '../../components/PastInstalls/PastInstalls';
import TotalPayments from '../../components/TotalPayments/TotalPayments';
import UpcomingPayments from '../../components/UpcomingPayments/UpcomingPayments';
import BonusesEarned from '../../components/BonusesEarned/BonusesEarned';

import './payments.css';

export default function Payments() {
  const { data } = useContext(DataContext);

  return (
    <div className="payments container pt-3 pb-4 mb-5">
      <header className="pb-3 text-left">
        <h4 className="font-weight-normal text-center">Your Payments</h4>
      </header>
      {data && <div>
        <TotalPayments totalPayments={data.payments.pastPayments} />
        <UpcomingPayments upcomingPayments={data.payments.upcomingPayments} />
        <BonusesEarned bonusesEarned={data.payments.bonusesEarned} />
        <FutureEarnings futureEarnings={data.payments.potentialFutureEarnings} />
        {/* <PastInstalls payments={data.payments} /> */}
      </div>}
    </div>
  );
}
